<template>
  <div class="report__interest-indicator-card" :style="styles">
    <display-title :text="value"></display-title>
    <p class="report__interest-indicator-label">{{ label }}</p>
  </div>
</template>
<script>
import {DEFAULT_BRAND_SECONDARY_COLOR, REPORT_BORDER_RADIUS} from '../constants';
import DisplayTitle from '../Common/DisplayTitle.vue';

export default {
  inject: ['getBrandSecondaryBackground'],
  props: {
    label: String,
    value: [String, Number]
  },
  components: {
    DisplayTitle,
  },
  computed: {
    styles() {
      const brandPrimaryBackground = this.getBrandSecondaryBackground();
      return {
        backgroundColor: brandPrimaryBackground || DEFAULT_BRAND_SECONDARY_COLOR,
        borderRadius: REPORT_BORDER_RADIUS,
      };
    },
  },
};
</script>

<style scoped>
.report__interest-indicator-card {
  padding: 24px;
  text-align: center;
}

.report__interest-indicator-card .report__display-title {
  color: white;
}

.report__interest-indicator-label {
  margin-bottom: 0px;
  color: white;
  font-weight: 700;
}
</style>
